/**
 * On every failed request, if it is a 401 error that was not caused by a key action, assume it to
 * be an expired session token and dispatch a session-wide error. The app should then handle this
 * by telling the user to sign in again.
 *
 * Ignore certain key actions because they require HTTP Basic authentication, and 401s resulting
 * from those aren't session expired errors.
 */
import { SESSION_ERROR } from '../modules/session';

/* Match all failed requests except for ones from modifying keys */
const RequestFailRegex = /^(?!KEYS::(DELETE|POST|PUT)).*REQUEST_FAIL/;

export default () => next => (action) => {
  if (action.type.match(RequestFailRegex)) {
    const { error } = action;

    if (error.statusCode === 401) {
      error.error.message = 'Your session appears to have expired. Please click below to sign in.';
      return next({ type: SESSION_ERROR, error });
    }
  }

  return next(action);
};
